import { Controller } from 'react-hook-form';
import { ReactComponent as CloseIcon } from 'assets/icons/close.svg';
import IconButton from 'components/IconButton/IconButton';
import TextField from 'components/TextField/TextField';

import type { ICreateSurveyQuestionSelectOption } from '../interfaces/ICreateSurveyQuestionSelectOption';

import styles from '../scss/CreateSurveyOptions.module.scss';

function CreateSurveyQuestionSelectOption({
  control,
  questionIndex,
  index,
  onRemoveOption,
}: ICreateSurveyQuestionSelectOption) {
  return (
    <Controller
      control={control}
      name={`questions.${questionIndex}.options.${index}.name`}
      render={({ field: { name, value, onChange }, fieldState: { error } }) => (
        <TextField
          name={name}
          value={value}
          placeholder={`Option ${index + 1}`}
          className={styles.radioOptionContent}
          error={error?.message}
          afterAddon={(index > 0) ? (
            <IconButton
              icon={<CloseIcon />}
              onClick={() => onRemoveOption(index)}
              className={styles.deleteOptionButton}
            />
          ) : null}
          onChange={(event) => onChange(event.target.value)}
          required
        />
      )}
    />
  );
}

export default CreateSurveyQuestionSelectOption;
